// extracted by mini-css-extract-plugin
var _1 = "R89uj";
var _2 = "_3YI8p";
var _3 = "AG2cg";
var _4 = "NW3bu";
var _5 = "g86Tq";
var _6 = "tmvHB";
var _7 = "HTjWu";
var _8 = "ZErk9";
var _9 = "y3Pli";
var _a = "N_JLX";
export { _1 as "active", _2 as "button", _3 as "grey", _4 as "lightgrey", _5 as "position", _6 as "positionRight", _7 as "red", _8 as "s0", _9 as "s1", _a as "s2" }
